import * as React from "react";
import "./tab1.scss";

const Tab1 = () => {
    return (
        <div className="Tab1">

        </div>
    );
}

export default Tab1;